module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/_babel-runtime@6.23.0@babel-runtime/core-js/array/from.js
 ** module id = 372
 ** module chunks = 0 1
 **/